<app-input type="textarea" [(model)]="textualLogins" label="Lista delle login" [ignoreMaxLength]="true"></app-input>
<br>
<app-input type="text" [(model)]="title" label="Titolo" [maxLength]="145"></app-input>
<br>
<app-input type="textarea" [(model)]="message" label="Testo" [ignoreMaxLength]="true"></app-input>
<br>
<button pButton pRipple class="p-button" (click)="createTickets()">Apri ticket</button>
<br>
